export const TOAST_ADD = 'Toasts/ADD'
export const TOAST_REMOVE = 'Toasts/REMOVE'
